<template>
  <div class="atb-full-height">
    <common-datagrid ref="commonDatagrid" ID="sysMenuIndex" :rowId="id" :pagination="false" :treeConfig="{ toggleMethod: toggleMethod }"
    :columns="columns" :url="$api.sys.menu.list" :params="search" :filterData="tableDataFilter">
      <template slot="searchForm">
        <el-form class="atb-search-form" :inline="true" size="mini" 
        v-on:keyup.enter.native.prevent="loadData(1)" @submit.native.prevent>
          <!-- 菜单名称 -->
          <el-form-item label="菜单名称">
            <el-input v-model="search.MENU_NAME"></el-input>
          </el-form-item>
          <el-form-item>
            <!-- 查询 -->
            <el-button type="primary" icon="el-icon-search" @click="loadData(1)">查询</el-button>
            <!-- 新建 -->
            <el-button class="el-button--primary_dark" icon="el-icon-plus" @click="createByParentMenu()">新建</el-button>
          </el-form-item>
        </el-form>
      </template>
      <template v-slot:option="{ row }">
        <!-- 新建 -->
        <el-tooltip content="新建" open-delay="500">
          <el-button size="mini" type="success" icon="el-icon-plus" circle @click="createByParentMenu(row)"></el-button>
        </el-tooltip>
        <!-- 编辑 -->
        <el-tooltip content="编辑" open-delay="500">
          <el-button size="mini" type="primary" icon="el-icon-edit" circle @click="add(row)"></el-button>
        </el-tooltip>
        <!-- 删除 -->
        <el-tooltip content="删除" open-delay="500">
          <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="deleteRow(row)"></el-button>
        </el-tooltip>
      </template>
      <!-- 时间格式 -->
      <template v-slot:date="{ row,column }">
        {{(row[column.field] && new Date(row[column.field]) || '') | formatDate('yyyy-MM-dd hh:mm:ss')}}
      </template>
      <!-- 是与否 -->
      <template v-slot:yesOrNo="{ row,column }">
        {{ row[column.field] == 1 ? '是' : '否' }}
      </template>
    </common-datagrid>
    <common-dialog ref="commonDialog" :title="dialogContent.title" width="900px">
      <template slot="content">
        <component v-bind:is="dialogContent.componentName" :editData="EditRow" :parentId="createByParentId" :autoMenuId="autoMenuId" @submitSuccess="loadData()"></component>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import tableMixin from '@/mixins/table.mixin'
export default {
  mixins: [ tableMixin ],
  components: {
    Add: ()=>import('./Add'),
  },
  data() {
    return {
      id: 'ID',
      // 用户删除
      deleteApi: this.$api.sys.menu.delete,
      // 数据表格
      columns: [
        { title: "操作", field: "option", width: "80", align: "center", fixed: "right", slot: 'option' },
        { title: "菜单编号", field: "MENU_ID", width: "80", treeNode: true },
        { title: "菜单名称", field: "MENU_NAME", width: "80" },
        { title: "父菜单编号", field: "PARENT_MENU_ID", width: "80" },
        { title: "菜单URL", field: "MENU_URL", width: "80" },
        { title: "菜单分组", field: "MENU_GROUP", width: "80" },
        { title: "排序", field: "SORT", width: "100" },
        { title: "更新人", field: "CREATER", width: "80" },
        { title: "更新时间", field: "CREATE_DATE", width: "80", slot: "date" },
      ],
      // 展开行记录
      expandRows: [],
      // 父ID
      createByParentId: '',
      // 自动生成的菜单ID
      autoMenuId: ''
    }
  },
  methods: {
    loadData(page) {
      this.$refs.commonDatagrid.loadData(page)
    },
    tableDataFilter(d){
      setTimeout(() => {
        let expandRows = JSON.parse(JSON.stringify(this.expandRows))
        this.expandRows = []
        this.getExpandRows(this.$refs.commonDatagrid.datalist,expandRows)
        this.$refs.commonDatagrid.$refs.mainTable.setTreeExpand(this.expandRows,true)
      }, 10);
      return this.packageMenu('00',d.Rows)
    },
    getExpandRows(list,cacheExpandRows){
      list.forEach(row=>{
        if(cacheExpandRows.find(val=>val[this.id] == row[this.id])){
          this.expandRows.push(row)
        }
        if(row.children && row.children.length){
          this.getExpandRows(row.children,cacheExpandRows)
        }
      })
    },
    packageMenu(parentId,menus){
      let children_menu = menus.filter(menu=>menu.PARENT_MENU_ID == parentId).sort((a,b)=>(a.SORT-b.SORT>0?1:-1))
      if(children_menu.length){
        for (let index = 0; index < children_menu.length; index++) {
          let menu = children_menu[index];
          menu.children = this.packageMenu(menu.MENU_ID,menus)
        }
      }
      return children_menu
    },
    createByParentMenu(row){
      this.EditRow = {};
      this.createByParentId = row && row.MENU_ID || '00'
      if(row){
        if(row.children && row.children.length){
          let menuId = row.children[row.children.length-1].MENU_ID.replace(row.MENU_ID,'')
          let menuId2 = this.$str_num_add(menuId,1)
          if(String(menuId2).length < menuId.length) menuId2 = '0' + menuId2
          this.autoMenuId = row.MENU_ID + menuId2 
        }else{
          this.autoMenuId = row.MENU_ID + '01'
        }
      }else{
        let list = this.$refs.commonDatagrid.datalist
        if(list && list.length){
          let menuId = list[list.length-1].MENU_ID
          let menuId2 = this.$str_num_add(menuId,1)
          if(String(menuId2).length < menuId.length) menuId2 = '0' + menuId2
          this.autoMenuId = menuId2 
        }else{
          this.autoMenuId = '01'
        }
      }
      //日常弹窗公共写法
      this.dialogContent = {
        title: '新建',
        componentName: 'Add'
      };
      this.$refs.commonDialog.show();
    },
    toggleMethod(){
      setTimeout(() => {
        this.expandRows = this.$refs.commonDatagrid.$refs.mainTable.getTreeExpandRecords()
      }, 10);
      return true
    }
  }
}
</script>
